$(function () {
    /**
     * Open rel="external" links in a new tab.
     */
    $(document).on("click", "a[rel=external]", function () {
        $(this).attr("target", "_blank");
    });

    $("#infoPanel").find("a[data-menu]").flyout();
    $("#nav")
        .touchMenu()
        .scrollToTop({
            cancel: function () {
                return !$(this).parent().hasClass("has-submenu");
            },
        });

    /* Replace all editor video/audio placeholders
     */
    $.fn.schoolboxResource_ProxyReplacement("#content");

    // Notifications dock/undock
    $("#right-menu-dock").on("click", function (event) {
        event.preventDefault();

        var dockState = $(this).data("dock-state");

        // Adjust classes
        if (dockState) {
            $("#inner-wrap").removeClass("right-open");
        } else {
            $("#inner-wrap").addClass("right-open");
        }

        $("#off-canvas-wrap").removeClass("move-left");

        // Update the hover title on the dock button
        var title = dockState ? $(this).data("title-dock") : $(this).data("title-undock");
        $(this).attr("title", title);

        var notificationState = dockState ? "hide" : "show";
        $.post("/ajax/notificationsTray", { state: notificationState });

        // Update dock state in the element's data property
        $(this).data("dock-state", !dockState);

        // Update top nav items
        updateTopNavItems();
    });

    // Left menu dock/undock
    $("#left-menu-dock").on("click", function (event) {
        event.preventDefault();

        var dockState = $(this).data("dock-state");

        // Adjust classes
        if (dockState) {
            $("#inner-wrap").removeClass("left-open");
        } else {
            $("#inner-wrap").addClass("left-open");
        }

        $("#off-canvas-wrap").removeClass("move-right");

        // Update the hover title on the dock button
        var title = dockState ? $(this).data("title-dock") : $(this).data("title-undock");
        $(this).attr("title", title);

        // Update the user's sidebar state in the DB
        var leftnavState = dockState ? "hide" : "show";
        $.post("/ajax/sidenav", { state: leftnavState });

        // Update dock state in the element's data property
        $(this).data("dock-state", !dockState);

        // Update top nav items
        updateTopNavItems();
    });

    /* Open / Close account menu
     * + click outside div to close
     */
    const accountMenu = $("#account-content");
    const profileDrop = $("#profile-drop");

    profileDrop.on("click", function (e) {
        e.stopPropagation();
        accountMenu.toggleClass("open");
    });

    // If the user clicks anywhere in the document, close the account menu
    // OR if the document gets blurred, close the account menu (Accounts for if users click inside an iframe)
    document.addEventListener("click", () => accountMenu.removeClass("open"));
    window.addEventListener("blur", () => accountMenu.removeClass("open"));

    /* Ensure modals always appear in a visible location
     *
     * The callback open.fndtn.reveal doesn't fire when the
     * modal is built dynamically with js -_-
     *
     * Also, arbitrary 6.25rem padding at top (in the design)
     */
    var modalTop = 6.25 * 16;

    $(document).on("open.fndtn.reveal", "[data-reveal]", function () {
        $(this).css({ top: $(window).scrollTop() + modalTop + "px" });
    });

    $(document).on("opened.fndtn.reveal", "[data-reveal]", function () {
        $(this).css({ top: $(window).scrollTop() + modalTop + "px" });
    });

    /**
     * Hack into Phpdebugbar to add a twig templates button
     */
    var $debugBar = $(".phpdebugbar .phpdebugbar-header-right");
    if ($debugBar.length > 0) {
        // Add the button to the debug bar
        var $html =
            '<span class="phpdebugbar-indicator">' +
            '<a id="showTwigNames">' +
            '<i class="phpdebugbar-fa phpdebugbar-fa-leaf" style="color:#555"></i>' +
            "</a>" +
            '<span class="phpdebugbar-tooltip">Twig templates</span>' +
            "</span>";
        $debugBar.find(".phpdebugbar-indicator").first().before($html);

        // Toggle twig template names showing on click of the button
        $("#showTwigNames").click(function () {
            if ($(".twigName").attr("hidden")) {
                $(".twigName").removeAttr("hidden");
            } else {
                $(".twigName").attr("hidden", true);
            }
        });
    }

    /**
     * Show/hide top nav items based on space available
     */
    function updateTopNavItems() {
        var $searchButton = $("[data-header-search-button]").first();
        if ($searchButton.length === 0) {
            // don't need to continue if the search button doesn't exist
            return;
        }

        // A separator used to break up the menu items from the profile menu that appears above it in mobile.
        const sideNavSeparator = document.querySelector("li[data-sidenav-separator]");
        let secondNavHasItems = false;
        let hideRemainingItems = false;

        // Reset the nav before measuring positions, otherwise hidden items report no geometry.
        $("#top-menu > li").each(function () {
            toggleTopNavItem(true, $(this));
        });

        var $topMenuItems = $("#top-menu > li");
        var $tabBar = $("nav.tab-bar");
        var searchButtonLeft = $searchButton.get(0).getBoundingClientRect().left;
        var tabBarRight = $tabBar.length > 0 ? $tabBar.get(0).getBoundingClientRect().right : searchButtonLeft;
        var isCompactTopBar = $tabBar.length > 0 ? Math.abs($tabBar.outerHeight() - 72) < 1 : true;
        var overflowBoundary = isCompactTopBar ? searchButtonLeft : tabBarRight;
        var firstItemTop = null;

        $topMenuItems.each(function (index) {
            var itemRect = $(this).get(0).getBoundingClientRect();
            var itemRight = itemRect.right;

            if (firstItemTop === null) {
                firstItemTop = itemRect.top;
            }

            if (!hideRemainingItems && (overflowBoundary <= itemRight || itemRect.top > firstItemTop + 1)) {
                hideRemainingItems = true;
            }

            if (hideRemainingItems) {
                toggleTopNavItem(false, $(this));
                secondNavHasItems = true;
            } else {
                toggleTopNavItem(true, $(this));
            }
        });

        // If any items are visible in the sidebar and a separator exists, show it.
        if (sideNavSeparator) {
            if (secondNavHasItems) {
                sideNavSeparator.style.display = "list-item";
            } else {
                sideNavSeparator.style.display = "none";
            }
        }
    }

    /**
     * Show a top nav item, and hide from the sidebar
     *
     * @param {boolean} show
     * @param {Object} $item
     */
    function toggleTopNavItem(show, $item) {
        var itemId = $item.data("id");

        // Show top nav
        show ? $item.show() : $item.hide();

        // Hide this item from the sidebar
        var $sidebarItem = $("#overflow-nav li[data-id=" + itemId + "]");
        show ? $sidebarItem.hide() : $sidebarItem.show();
    }

    // Run the top nav update on page load
    updateTopNavItems();

    // Listen for changes to window size and run the top nav update
    // Apply a timeout so that the function doesn't run a million times while resizing
    var resizeTimeout;
    $(window).resize(function () {
        this.clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateTopNavItems, 100);
    });

    // Set a data-test-ready="true" attribute as a flag for playwright tests
    // to ensure that we've successfully added the listener to the profile drop (and other parts of this script have finished)
    profileDrop.attr("data-test-ready", "true");

    // Override the default iconSprite reference and leave blank to avoid load error
    // CSS is used to display the icons instead
    // refer to https://github.com/mediaelement/mediaelement/blob/master/docs/api.md#configuration
    const originalMediaElementPlayer = $.fn.mediaelementplayer;
    $.fn.mediaelementplayer = function (options) {
        const defaultOptions = {
            iconSprite: ``,
        };
        const mergedOptions = $.extend(true, {}, defaultOptions, options);
        return originalMediaElementPlayer.call(this, mergedOptions);
    };
});

/**
 * Show a loader overlay over the entire page when
 * document.dispatchEvent(new Event("OVERLAY_LOADER_SHOW")); is called
 */
document.addEventListener("OVERLAY_LOADER_SHOW", function (e) {
    const existingLoader = document.querySelector("[data-loader-overlay]");
    if (!existingLoader) {
        const overlayLoaderHTML = `
        <div data-loader-overlay class="loader-overlay">
            <div class="preview loader"></div>
        </div>`;
        document.body.insertAdjacentHTML("beforeend", overlayLoaderHTML);
    }
});

/**
 * Hide the entire page loader when
 * document.dispatchEvent(new Event("OVERLAY_LOADER_HIDE")); is called
 */
document.addEventListener("OVERLAY_LOADER_HIDE", function (e) {
    const existingLoader = document.querySelector("[data-loader-overlay]");
    if (existingLoader) {
        existingLoader.remove();
    }
});
